import {
    EnvironmentProviders,
    inject,
    provideAppInitializer,
    Provider,
} from '@angular/core';
import { AmplitudeConfig } from '../../models/amplitude-config/amplitude-config.model';
import { AmplitudeService } from '../../services/amplitude/amplitude.service';
import { AMPLITUDE_CONFIG } from './amplitude-config.token';
import { AbstractUserInfoService } from 'shared/core/data-access/user-info';
import { firstValueFrom } from 'rxjs';

export const provideAmplitude = (
    config?: AmplitudeConfig,
): (Provider | EnvironmentProviders)[] => [
    {
        provide: AMPLITUDE_CONFIG,
        useValue: config ?? {},
    },
    provideAppInitializer(() => {
        const userInfoService = inject(AbstractUserInfoService);
        const amplitudeService = inject(AmplitudeService);

        return firstValueFrom(userInfoService.getUserInfo()).then(
            (userInfo) => {
                amplitudeService.init({
                    userId: userInfo?.subject,
                    roles: userInfo?.roles,
                });
            },
        );
    }),
];
